import { createHttpContextFromOptions } from '@quipex/core/primitives';
import type {
    BuildingOwnershipTransferDecision,
    BuildingOwnershipTransferResponse,
    BuildingsApiService,
    OwnershipTransferRecipientPreviewResponse,
    OrganisationsApiService,
    StartBuildingOwnershipTransferRequest,
} from '@quipex/shared/contracts';
import type { Observable } from 'rxjs';

export function startBuildingOwnershipTransfer(
    buildingsApi: BuildingsApiService,
    buildingId: string,
    request: StartBuildingOwnershipTransferRequest
): Observable<BuildingOwnershipTransferResponse> {
    const context = createHttpContextFromOptions({
        // The transfer dialog maps ProblemDetails into transfer-specific feedback.
        suppressAutoErrorToast: true,
    });

    return buildingsApi.createBuildingOwnershipTransfer(buildingId, request, {
        context,
    });
}

export function previewBuildingOwnershipTransferRecipient(
    buildingsApi: BuildingsApiService,
    buildingId: string,
    email: string
): Observable<OwnershipTransferRecipientPreviewResponse> {
    const context = createHttpContextFromOptions({
        // The dialog owns neutral inline unavailable/error states for this privacy-sensitive preview.
        suppressAutoErrorToast: true,
    });

    return buildingsApi.createBuildingOwnershipTransferRecipientPreview(
        buildingId,
        { email },
        { context }
    );
}

export function decideBuildingOwnershipTransfer(
    organisationsApi: OrganisationsApiService,
    organisationId: string,
    transferId: string,
    decision: BuildingOwnershipTransferDecision
): Observable<BuildingOwnershipTransferResponse> {
    const context = createHttpContextFromOptions({
        // The confirmation workflow owns accept or reject progress and failure copy.
        suppressAutoErrorToast: true,
    });

    return organisationsApi.createOrganisationBuildingOwnershipTransfer(
        organisationId,
        transferId,
        { decision },
        { context }
    );
}
